import request from './request';

const PERMISSIONS_KEY = 'permissions';
const ROLES_KEY = 'roles';
const SUPER_ADMIN_KEY = 'superAdmin';
const USER_TYPE_KEY = 'userType';

function parseArray(value) {
  try {
    const parsed = JSON.parse(value || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

export async function bootstrapPermissions() {
  const res = await request.get('/api/system/user/permissions');
  const permissions = res?.permissions || [];
  const roles = res?.roles || [];
  localStorage.setItem(PERMISSIONS_KEY, JSON.stringify(permissions));
  localStorage.setItem(ROLES_KEY, JSON.stringify(roles));
  localStorage.setItem(SUPER_ADMIN_KEY, res?.superAdmin ? '1' : '0');
  localStorage.setItem(USER_TYPE_KEY, res?.userType || '');
  window.dispatchEvent(new Event('permissions-updated'));
  return res;
}

export function hasPermissionCache() {
  return localStorage.getItem(PERMISSIONS_KEY) != null;
}

export function getPermissions() {
  return parseArray(localStorage.getItem(PERMISSIONS_KEY));
}

export function isSuperAdmin() {
  return localStorage.getItem(SUPER_ADMIN_KEY) === '1';
}

export function can(code) {
  if (!code) return true;
  if (isSuperAdmin()) return true;
  const permissions = getPermissions();
  return permissions.includes('*:*:*') || permissions.includes(code);
}

export function canAny(prefix) {
  if (!prefix) return true;
  if (isSuperAdmin()) return true;
  const permissions = getPermissions();
  return permissions.includes('*:*:*') || permissions.some((item) => item.startsWith(prefix));
}

export function clearPermissions() {
  localStorage.removeItem(PERMISSIONS_KEY);
  localStorage.removeItem(ROLES_KEY);
  localStorage.removeItem(SUPER_ADMIN_KEY);
  localStorage.removeItem(USER_TYPE_KEY);
}
